/**
 * ntc-griglia.js — la griglia prodotti «viva» (collezioni e ricerca), 11/09/2026 — secondo giro «osare di più».
 *
 * ⭐ Le schede entrano mentre si scorre (solo quelle SOTTO allo schermo: quelle già visibili non lampeggiano); si
 *    inclinano col mouse con riflesso e anello rosso; il prezzo sale quando la scheda compare; una macchinina attraversa
 *    «Aggiungi al carrello» e il fulmine «parte» all'aggiunta; «Va sulla tua …» per l'auto scelta nella barra;
 *    testata della marca con le scie.
 * ⚠️ Senza questo file la griglia resta com'è (niente è nascosto finché lo script non gira).
 * ⚠️ Il prezzo si anima sul TESTO e alla fine si rimette esattamente quello di prima.
 * ⛔ Il modulo d'acquisto è quello del tema: qui si ascolta il submit, non lo si ferma mai.
 */
(function () {
  'use strict';

  var calma = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mouse = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var cfg = (document.currentScript && document.currentScript.dataset) || {};
  var INCLINA = cfg.inclina !== 'false';
  var PREZZI = cfg.prezzi !== 'false';

  function scelta() {
    try {
      var s = window.localStorage.getItem('ntc_auto');
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }
  var auto = scelta();
  var tagAuto = auto && auto.tag ? String(auto.tag).toLowerCase() : '';
  /* la pagina è già filtrata su quell'auto: ogni scheda ci va, non serve dirlo 24 volte */
  var giaFiltrata = tagAuto && decodeURIComponent((window.location.search || '').replace(/\+/g, ' ')).toLowerCase().indexOf(tagAuto) >= 0;

  /* ── il prezzo che sale ───────────────────────────────────────────────────────────────── */
  function sali(card) {
    if (calma || !PREZZI) { return; }
    var el = card.querySelector('.price .price-item-sale') || card.querySelector('.price .price-item-regular');
    if (!el) { return; }
    var nodo = null;
    for (var i = 0; i < el.childNodes.length; i++) {
      if (el.childNodes[i].nodeType === 3 && /\d/.test(el.childNodes[i].textContent)) { nodo = el.childNodes[i]; break; }
    }
    if (!nodo || nodo.__ntcSalito) { return; }
    nodo.__ntcSalito = true;
    var originale = nodo.textContent;
    var m = originale.match(/^([\s\S]*?)(\d[\d.,]*)([\s\S]*)$/);
    if (!m) { return; }
    var cifre = m[2], dec = '', sep = '';
    var ul = Math.max(cifre.lastIndexOf('.'), cifre.lastIndexOf(','));
    if (ul >= 0 && cifre.length - ul - 1 === 2) { sep = cifre.charAt(ul); dec = cifre.slice(ul + 1); cifre = cifre.slice(0, ul); }
    var gruppo = sep === ',' ? '.' : ',';
    var intero = parseInt(cifre.replace(/[.,]/g, ''), 10);
    if (!(intero > 0)) { return; }
    function forma(n) {
      var s = String(n);
      return cifre.indexOf(gruppo) >= 0 ? s.replace(/\B(?=(\d{3})+(?!\d))/g, gruppo) : s;
    }
    el.style.minWidth = Math.ceil(el.getBoundingClientRect().width) + 'px';
    var t0 = performance.now(), durata = 650;
    (function passo(t) {
      var k = Math.min(1, (t - t0) / durata), e = 1 - Math.pow(1 - k, 3);
      if (k < 1) {
        nodo.textContent = m[1] + forma(Math.round(intero * e)) + (sep ? sep + dec : '') + m[3];
        requestAnimationFrame(passo);
      } else {
        nodo.textContent = originale;
        el.style.minWidth = '';
      }
    })(t0);
  }

  /* ── inclinazione col mouse, riflesso e anello ────────────────────────────────────────── */
  function inclina(card) {
    if (!mouse || calma || !INCLINA || card.querySelector('.ntc-card-luce')) { return; }
    var luce = document.createElement('span');
    luce.className = 'ntc-card-luce';
    luce.setAttribute('aria-hidden', 'true');
    var anello = document.createElement('span');
    anello.className = 'ntc-card-anello';
    anello.setAttribute('aria-hidden', 'true');
    card.appendChild(luce);
    card.appendChild(anello);
    var giro = 0, ex = 0, ey = 0;
    /* 14/09: si ascolta la CELLA, che non si muove: la scheda alzata di 8 px lasciava il mouse fuori sul bordo basso
       → pointerleave → giù → di nuovo dentro → sfarfallio */
    var zona = card.parentElement && card.parentElement.classList.contains('grid-item') ? card.parentElement : card;
    zona.addEventListener('pointermove', function (e) {
      ex = e.clientX;
      ey = e.clientY;
      if (giro) { return; }
      giro = requestAnimationFrame(function () {
        giro = 0;
        var r = card.getBoundingClientRect();
        if (!r.width) { return; }
        var px = Math.min(1, Math.max(0, (ex - r.left) / r.width)), py = Math.min(1, Math.max(0, (ey - r.top) / r.height));
        card.style.setProperty('--ntc-ry', ((px - 0.5) * 9).toFixed(2) + 'deg');
        card.style.setProperty('--ntc-rx', ((0.5 - py) * 7).toFixed(2) + 'deg');
        card.style.setProperty('--ntc-lx', (px * 100).toFixed(1) + '%');
        card.style.setProperty('--ntc-ly', (py * 100).toFixed(1) + '%');
        card.classList.add('ntc-in-volo');
      });
    });
    zona.addEventListener('pointerleave', function () {
      card.classList.remove('ntc-in-volo');
      card.style.removeProperty('--ntc-rx');
      card.style.removeProperty('--ntc-ry');
    });
  }

  /* ── lampo e macchinina nel pulsante (elementi <i>: i selettori del testo guardano «> span») ── */
  function pulsante(card) {
    var b = card.querySelector('.button-add-to-cart');
    if (!b || b.querySelector('.ntc-corsa')) { return; }
    var lampo = document.createElement('i');
    lampo.className = 'ntc-lampo';
    lampo.setAttribute('aria-hidden', 'true');
    var corsa = document.createElement('i');
    corsa.className = 'ntc-corsa';
    corsa.setAttribute('aria-hidden', 'true');
    b.insertBefore(corsa, b.firstChild);
    b.insertBefore(lampo, b.firstChild);
  }

  /* ── entrata mentre si scorre ─────────────────────────────────────────────────────────── */
  var fila = 0, azzera = 0;
  var io = (!calma && 'IntersectionObserver' in window) ? new IntersectionObserver(function (voci) {
    voci.forEach(function (v) {
      if (!v.isIntersecting) { return; }
      io.unobserve(v.target);
      var c = v.target;
      var ritardo = fila * 70;
      c.style.setProperty('--ntc-ritardo', ritardo + 'ms');
      fila += 1;
      c.classList.add('is-rivelata');
      setTimeout(function () { sali(c); }, ritardo + 150);
      setTimeout(function () {
        c.classList.remove('ntc-da-rivelare', 'is-rivelata');
        c.style.removeProperty('--ntc-ritardo');
      }, 1300 + ritardo);
    });
    clearTimeout(azzera);
    azzera = setTimeout(function () { fila = 0; }, 120);
  }, { rootMargin: '0px 0px -6% 0px' }) : null;

  var subito = 0;
  function tratta(card) {
    card.setAttribute('data-ntc-vista', '');
    if (tagAuto && !giaFiltrata) {
      var tags = (card.getAttribute('data-ntc-tags') || '').toLowerCase().split('|');
      var info = card.querySelector('.card-info');
      /* ⛔ solo se l'auto scelta è più di una marca: «Alfa Romeo Giulietta» allunga «Alfa Romeo», «Audi» non allunga
         niente — «Va sulla tua Audi» su ogni scheda Audi non direbbe nulla */
      var precisa = tags.some(function (t) { return t && t !== tagAuto && tagAuto.indexOf(t + ' ') === 0; });
      if (precisa && tags.indexOf(tagAuto) >= 0 && info && !info.querySelector('.ntc-card-tua')) {
        var s = document.createElement('span');
        s.className = 'ntc-card-tua';
        s.textContent = 'Va sulla tua ' + (auto.nome || auto.tag);
        info.appendChild(s);
      }
    }
    inclina(card);
    pulsante(card);
    if (io && card.getBoundingClientRect().top > window.innerHeight * 0.94) {
      card.classList.add('ntc-da-rivelare');
      io.observe(card);
    } else {
      var n = subito++;
      setTimeout(function () { sali(card); }, 250 + n * 60);
    }
  }
  function giro() {
    subito = 0;
    /* 12/09: anche le vetrine della home (.ntc-vetrina), non le altre griglie della home */
    document.querySelectorAll(':is(.template-collection, .template-search) .product-grid .card-product:not([data-ntc-vista]), .ntc-vetrina .card-product:not([data-ntc-vista])').forEach(tratta);
  }

  /* ── testata della marca: le scie sulla foto ──────────────────────────────────────────── */
  function testata() {
    var b = document.querySelector('.collection-hero-banner');
    if (calma || !b || b.querySelector('.ntc-banner-scie')) { return; }
    var s = document.createElement('span');
    s.className = 'ntc-banner-scie';
    s.setAttribute('aria-hidden', 'true');
    s.innerHTML = '<i></i><i></i><i></i><i></i>';
    var img = b.querySelector('.collection-hero-banner-media');
    if (img) { img.insertAdjacentElement('afterend', s); } else { b.insertBefore(s, b.firstChild); }
  }

  document.documentElement.classList.add('ntc-griglia-js');
  testata();
  giro();

  /* i filtri e le pagine successive ridisegnano la griglia */
  var attesa = 0;
  new MutationObserver(function () {
    if (attesa) { return; }
    attesa = requestAnimationFrame(function () { attesa = 0; giro(); });
  }).observe(document.getElementById('ProductGridContainer') || document.body, { childList: true, subtree: true });

  /* il fulmine «parte» quando si aggiunge (si ascolta e basta) */
  document.addEventListener('submit', function (e) {
    if (calma) { return; }
    var f = e.target;
    if (!f || !f.closest || !f.closest('.product-grid .card-product, .ntc-vetrina .card-product')) { return; }
    var b = f.querySelector('.button-add-to-cart');
    if (!b) { return; }
    b.classList.remove('ntc-parte');
    void b.offsetWidth;
    b.classList.add('ntc-parte');
    setTimeout(function () { b.classList.remove('ntc-parte'); }, 900);
  }, true);

  /* ── 14/09: tutta la scheda porta al prodotto ──────────────────────────────────────────────────
     L'utente: «spesso il click va a vuoto… meglio rendere cliccabile un'area più ampia»: erano link solo foto e titolo.
     ⛔ I controlli restano loro (pulsante e modulo del carrello, link del marchio e delle recensioni, campi).
     ⛔ Niente dopo un trascinamento del carosello (Flickity annulla il clic → defaultPrevented) o con testo selezionato.
     Ctrl/⌘/Maiusc o rotellina = scheda nuova, come su un link vero. */
  var SCHEDE = ':is(.template-collection, .template-search) .product-grid .card-product, .ntc-vetrina .card-product';
  function schedaDa(t) {
    if (!t || !t.closest) { return null; }
    var card = t.closest('.card-product');
    if (!card && t.classList && t.classList.contains('grid-item')) { card = t.querySelector(':scope > .card-product'); }
    return card && card.matches(SCHEDE) ? card : null;
  }
  function apri(e) {
    if (e.defaultPrevented) { return; }
    if (e.type === 'click' && e.button !== 0) { return; }
    if (e.type === 'auxclick' && e.button !== 1) { return; }
    var t = e.target;
    var card = schedaDa(t);
    var CONTROLLI = 'a[href], button, input, select, textarea, label, summary, [role="button"], [contenteditable], form';
    if (!card || t.closest(CONTROLLI)) { return; }
    /* 14/09 bis: clic arrivato alla CELLA (striscia sotto alla scheda alzata): se il punto cade su un controllo della scheda
       non si apre niente — mai portare via dalla pagina chi voleva «Aggiungi al carrello» */
    if (!card.contains(t)) {
      var ctrl = card.querySelectorAll(CONTROLLI);
      for (var i = 0; i < ctrl.length; i++) {
        var q = ctrl[i].getBoundingClientRect();
        if (e.clientX >= q.left && e.clientX <= q.right && e.clientY >= q.top && e.clientY <= q.bottom) { return; }
      }
    }
    if (window.getSelection && String(window.getSelection()).trim()) { return; }
    var link = card.querySelector('.card-heading a[href]') || card.querySelector('a.js-product-link[href]');
    if (!link) { return; }
    if (e.type === 'auxclick' || e.ctrlKey || e.metaKey || e.shiftKey) {
      e.preventDefault();
      window.open(link.href, '_blank', 'noopener');
      return;
    }
    link.click();
  }
  document.addEventListener('click', apri);
  document.addEventListener('auxclick', apri);
})();
